import React, { useState, useEffect } from 'react'
import axios from 'axios'
import * as yup from 'yup'
import { useHistory } from "react-router-dom";
import {axiosWithAuth} from './axiosWithAuth'
import styled from 'styled-components'

const initialFormValues = {
    name: '',
    password:'',
    email: '',
    role:'',
    terms: false
  }

  const initialErrors = {
    name: '',
    password:'',
    email: '',
    role:'',
    terms: false
  }

  const schema = yup.object().shape({
     name: yup.string().required("You must enter a username").min(6, 'NEED AT LEAST 6 CHARACTERS'),
      email:yup.string().required('Must enter an email'),
      password:yup.string().required('You must enter a valid password').min(8, 'MUST BE 8 CHARACTERS LONG'),
      role:yup.string().oneOf(['0', '1']).required('Must pick a role'),
      terms: yup.boolean().oneOf([true, false]).required('Must accept Terms & Conditions')
  })

  const StyledSignIn = styled.div`

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #242943;
  color: white;


  form {
    display: flex;
    flex-direction: column;
    align-items: start;
  }

  h4 {
    color: #138CFE;
  }

  .role {
    margin-bottom: 10%;
    width: 129.5%;
  }

  button {
    margin: 15% 0;
    box-shadow: inset 0px 1px 0px 0px #bee2f9;
    background: linear-gradient(to bottom, #63b8ee 5%, #468ccf 100%);
    background-color: #63b8ee;
    border-radius: 6px;
    border: 1px solid #3866a3;
    display: inline-block;
    cursor: pointer;
    color: #14396a;
    font-family: Arial;
    font-size: 15px;
    font-weight: bold;
    padding: 6px 24px;
    text-decoration: none;
    text-shadow: 0px 1px 0px #7cacde;
    &:hover {
      background: linear-gradient(to bottom, #468ccf 5%, #63b8ee 100%);
      background-color: #468ccf;
    }
    &:active {
      position: relative;
      top: 1px;
    }
  }

`;

export default function SignUp(){
const [form, setForm] = useState(initialFormValues)
// const [users, setUsers] = useState([])
const [disabled, setDisabled] = useState(true)
const [errors, setErrors] = useState(initialErrors)
const history = useHistory()

const setFormErrors = (name, value) => {
    yup
    .reach(schema, name)
    .validate(value)
    .then(() => setErrors({...errors, [name]:''}))
    .catch((err) => {
      setErrors({...errors, [name]:err.errors[0]})
    })
    }

    useEffect(() => {
    schema.isValid(form).then((valid) => setDisabled(!valid))
    }, [form])

    const change = (evt) => {
      const {checked, value, name, type} = evt.target;
      const whichValue = type === 'checkbox' ? checked : value;
      setFormErrors(name, whichValue);
      setForm({...form, [name]: whichValue})
    }

    const submit = (evt) => {
      evt.preventDefault()
      console.log('submit')
      const newMember = {
        name: form.name,
        password: form.password,
      };
      // if (!newMember.username || !newMember.password) {
      //   return;
      // }
      setForm(initialFormValues);
      postUser(newMember);
      console.log(newMember)
      history.push("/");
    }

    const postUser = (newUser) => {
      axiosWithAuth()
        .post("/auth/register", newUser)
        .then((response) => {
          console.log(response);
          localStorage.setItem('organizer_id', response.data.data.id)
          console.log(response.data.data.id)
        })
        .catch((error) => {
          console.error("Server Error", error);
        });
    };

    //   const newUser = {username: form.username.trim(), email: form.email.trim(), terms: form.terms}
    //   axios.post('/auth/register', newUser)
    //   .then(res => {
    //     setUsers([...users, res.data])
    //     setForm({ username: '', email: '', terms: false})
    //   })
    //   .catch(err => console.log(err))
    // }



    return (
    <StyledSignIn>
            <form onSubmit={submit}>
                <label>
                   <h4> Please enter username:</h4>
                <input name="name" type="text" onChange={change} value={form.username}/>
                </label>
                <label>
                <h4>Please enter password:</h4>
                <input name="password" type="password" onChange={change} value={form.password}/>
                </label>
                <label>
                <h4>Please enter an email:</h4>
                <input name="email" type="email" onChange={change} value={form.email}/>
                </label>
                <label > <h4>Please select a Role:</h4>
                    <select className="role">
                        <option value=''>Select a Role</option>
                        <option value='0'>Organizer</option>
                        <option value='1'>Guest</option>
                    </select>
                </label>
                <label className="conditions"> Please accept the Terms and Conditions:
                    <input name="terms" type="checkbox" onChange={change} checked={form.terms}/>
                </label>
                <label>
                    <button>Sign up!</button>
                </label>

            </form>
     </StyledSignIn>
    )
}